export const getParamCaseInsensitive = (searchParams: URLSearchParams, param: string) => {
  const lowercaseParam = param.toLowerCase();

  for (const [key, value] of searchParams.entries()) {
    if (key.toLowerCase() === lowercaseParam) {
      if (lowercaseParam === 'email') {
        try {
          return atob(value);
        } catch (e) {
          console.error('Error decoding Base64 email param:', e);
          return value; 
        }
      }

      return value;
    }
  }

  return null; 
};
